<template>
  <div
    v-if="isContentReady"
    class="row row--grid"
  >
    <template v-for="item in selection">
      <v-deal
        :item="item"
        :lexicon="lexicon" />
    </template>
  </div>
</template>

<script>
import  {
  getVehiclesListContent,
  getLexicon
} from '../rest-service/rest-service';
import VDeal from '../VDeal/VDeal.vue';
import VMixins from '../VMixins/VMixins.vue';

export default {
  name: "VDealsRandom",
  data () {
    return {
      selection: [],
      isContentReady: false,
      lexicon: {},
      page: 0,
      garageIds: [1011620]
    }
  },

  components: {
    VDeal
  },

  mixins: [VMixins],

  created() {

    getLexicon( this.lang,(response) => {
      this.lexicon = response.data
    })

    const getVehiclesListPage = (member, page, lang, makeId) => {
      return new Promise(resolve => {
        getVehiclesListContent({
          member: member,
          page: page,
          makeId: makeId,
          lng: lang
        },(result) => {
          const response = JSON.parse(result.data);
          resolve(response.Vehicles);
        })
      })
    }

    const getVehiclesContent = (member) => {
      return new Promise (resolve => {
        getVehiclesListContent({
          member: member,
          page: this.page,
          makeId: this.makeId,
          lng: this.lang
        },(result) => {
          const response = result.data;
          let temp = response.content
          this.page++
          let promises = [];
          for (let index = this.page; index < response.totalPages; index++) {
            promises = [...promises, ...[getVehiclesListPage(member, index, this.lang, this.makeId)]]
          }

          Promise.all(promises).then(result => {

            for (let batch of result) {
              try {
                temp = [...temp, ...batch];
              } catch (e) {
                continue;
              }
            }

            this.page = 1

            resolve(temp)
          })
        })
      })
    }

    Promise.all([
      getVehiclesContent(1011620),
    ]).then(result => {
        const deals = (result[0]) ?  [...result[0]].sort(() => 0.5 - Math.random()) : []

      if (this.modelName) {

        const temp = deals.filter(item => item.versionFullName.toLowerCase().startsWith(this.modelName.toLowerCase())).slice(0, 3)
        /*.includes(this.toSLug(this.modelName))*/
        if (temp.length) {
          this.selection = temp
        } else {
          this.selection = deals.slice(0, 3);
        }
      }
      else if (this.brandsExcluded) {
        const brandsToExcludedParsed = JSON.parse(this.brandsExcluded);
        this.selection = deals.filter(item => {
          return !brandsToExcludedParsed.some(cat => cat.brandName === item.make.name)
        }).slice(0, 3)
      }
      else {
        this.selection = deals.slice(0, 3);
      }

      this.isContentReady = true
    })


  },

  props: {
    makeId: Number|String,
    vehicleType: Number|String,
    exclude: Number,
    brandsExcluded: String,
    modelName: String
  }
}
</script>

